<template>
  <div class="app-loading" v-if="isLoading">
    <div class="hollow-dots-spinner">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([
      'isLoading',
    ]),
  },
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
</style>
